import { Controller } from "@hotwired/stimulus";
import { Target, TypedController } from "@vytant/stimulus-decorators";

// TODO: Extract this functionality to a different controller (probably in form_view)
@TypedController
export default class extends Controller {
  @Target
  private editButtonTarget: HTMLAnchorElement;

  connect() {
    this.editButtonTarget.addEventListener("click", (event) =>
      this.openDialog(event, this.editButtonTarget, this.dialog, `form-${this.editButtonTarget.dataset.model}-${this.editButtonTarget.dataset.id}`),
    );
  }

  private openDialog(event: Event, button: HTMLAnchorElement, dialog: HTMLDialogElement, frameId: string) {
    event.preventDefault();

    const newUrl = new URL(window.location.href);
    newUrl.searchParams.set("modal", `edit-${this.editButtonTarget.dataset.model}:${this.editButtonTarget.dataset.id}`);
    window.history.pushState(window.history.state, "", newUrl.toString());

    const url = new URL(button.href);
    url.pathname += "/edit";
    url.searchParams.set("frame", "true");

    const modalTemplate = document.getElementById("modal-template")!.cloneNode(true).content;
    modalTemplate.querySelector(".ref-title").innerHTML = button.dataset.title;

    const turboFrame = document.createElement("turbo-frame");
    turboFrame.id = frameId;
    turboFrame.src = url.toString();
    turboFrame.appendChild(modalTemplate);

    this.dialog.innerHTML = "";
    this.dialog.appendChild(turboFrame);

    this.dialog.showModal();

    this.dialog.addEventListener("close", () => {
      console.log("here");

      const newUrl = new URL(window.location.href);
      newUrl.searchParams.delete("modal");
      window.history.pushState(window.history.state, "", newUrl.toString());
    });
  }

  private get dialog() {
    return document.querySelector<HTMLDialogElement>("#edit-dialog")!;
  }
}
